import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Grid } from "@mui/material";
import CustomText from "components/typography/CustomText";
import React from "react";

export default function DailyNameTime({
  dayName = {},
  weekDay = "",
  onClick = () => {},
}) {
  return (
    <Grid
      container
      alignItems="center"
      justifyContent="space-between"
      spacing={4}
      className="cursor-pointer"
      onClick={onClick}
    >
      <Grid item className="mr-5">
        <CustomText variant="h6" bold={600}>
          {dayName ?? "Monday"}
        </CustomText>
        <CustomText variant="p">{weekDay ?? ""}</CustomText>
      </Grid>
      <Grid item className="mr-4" justifyContent="end">
        <KeyboardArrowDownIcon />
      </Grid>
    </Grid>
  );
}
